import OfficeDivisionTable from "./OfficeDivisionTable";

const OfficeDivision = () => {
  return (
    <>
      <OfficeDivisionTable />
    </>
  );
};

export default OfficeDivision;
